import axios from "../customize_axios"

export const getPendingReviews = async (token, page) => {
    try {
        const response = await axios.get(
            `api/review/admin/pending-list?page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getPendingReviews", error)
    }
}

export const getApprovedReviews = async (token, page) => {
    try {
        const response = await axios.get(
            `api/review/admin/approved-list?page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getApprovedReviews", error)
    }
}

export const getRejectedReviews = async (token, page) => {
    try {
        const response = await axios.get(
            `api/review/admin/rejected-list?page=${page}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getRejectedReviews", error)
    }
}

export const approveReview = async (token, reviewID) => {
    try {
        const response = await axios.post(
            `api/review/approve/${reviewID}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("approveReview", error)
    }
}

export const rejectReview = async (token, reviewID) => {
    try {
        const response = await axios.post(
            `api/review/reject/${reviewID}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("rejectReview", error)
    }
}